import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Footer from './Footer';
import MusicPlayer from './MusicPlayer';


import logo from "../img/logo.png"
// Icons object for consistent icon usage
const Icon = {
  Play: (p) => (<svg viewBox="0 0 24 24" fill="currentColor" className={p.className}><path d="M8 5v14l11-7z" /></svg>),
  Pause: (p) => (<svg viewBox="0 0 24 24" fill="currentColor" className={p.className}><path d="M6 5h4v14H6zM14 5h4v14h-4z" /></svg>),
  Heart: (p) => (<svg viewBox="0 0 24 24" fill="currentColor" className={p.className}><path d="M12.1 21.35l-1.1-.99C5.14 15.28 2 12.36 2 8.92 2 6.11 4.24 4 6.99 4c1.54 0 3.04.73 4.01 1.88A5.2 5.2 0 0115.01 4C17.76 4 20 6.11 20 8.92c0 3.44-3.14 6.36-8.99 11.44l-1.1.99z" /></svg>),
  HeartOutline: (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className={p.className}><path d="M12.1 20.3C6.2 15.2 3 12.3 3 8.9 3 6.1 5.2 4 7.9 4c1.6 0 3.1.8 4.1 2.1C13 4.8 14.5 4 16.1 4 18.8 4 21 6.1 21 8.9c0 3.4-3.2 6.3-8.9 11.4l-.1.1-.1-.1z" /></svg>),
  Search: (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={p.className}><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>),
  Clock: (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={p.className}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" /></svg>),
  SkipNext: (p) => (<svg viewBox="0 0 24 24" fill="currentColor" className={p.className}><path d="M6 6l8.5 6L6 18V6zm9.5 0h2v12h-2V6z" /></svg>),
  SkipPrev: (p) => (<svg viewBox="0 0 24 24" fill="currentColor" className={p.className}><path d="M18 6v12l-8.5-6L18 6zM5.5 6h2v12h-2z" /></svg>),
  Volume: (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={p.className}><path d="M11 5l-5 4H3v6h3l5 4V5z" /><path d="M15 9a4 4 0 010 6" /><path d="M17 7a7 7 0 010 10" /></svg>),
  Home: (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={p.className}><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" /><path d="M9 22V12h6v10" /></svg>),
  Library: (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={p.className}><path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z" /></svg>),
  Plus: (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={p.className}><path d="M12 5v14M5 12h14" /></svg>),
  Music: (p) => (<svg viewBox="0 0 24 24" fill="currentColor" className={p.className}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-3 5-3v6zm7 0l-5-3 5-3v6z"/></svg>),
  Settings: (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={p.className}><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z"/></svg>),
  Message: (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={p.className}><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>),
  Star: (p) => (<svg viewBox="0 0 24 24" fill="currentColor" className={p.className}><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>),
  Trending: (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={p.className}><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>),
  User: (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={p.className}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>),
  Logout: (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={p.className}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4\"/><polyline points="16 17 21 12 16 7\"/><line x1="21" y1="12" x2="9" y2="12"/></svg>),
};

const Sidebar = ({ sidebarOpen, setSidebarOpen, currentPath }) => {
  const navigate = useNavigate();

  const menuItems = [
    { icon: <Icon.Home className="w-5 h-5" />, text: "Home", path: "/Home" },

    // { icon: <Icon.Search className="w-5 h-5" />, text: "Search", path: "/search" },
    { icon: <Icon.User className="w-5 h-5" />, text: "Artists", path: "/artists" },
    { icon: <Icon.Library className="w-5 h-5" />, text: "Your Library", path: "/library" },
    // { icon: <Icon.Star className="w-5 h-5" />, text: "Favourites", path: "/favourite" },
    { icon: <Icon.Message className="w-5 h-5" />, text: "Chat", path: "/chat" },
    { icon: <Icon.Settings className="w-5 h-5" />, text: "Settings", path: "/settings" },

  ];
  const playlistItems = [
    { icon: <div className="w-5 h-5 rounded-sm bg-gradient-to-tr from-fuchsia-500 to-blue-500"></div>, text: "Create Playlist", path: "/create-playlist" },
    { icon: <div className="w-5 h-5 rounded-sm bg-gradient-to-tr from-blue-400 to-emerald-500"></div>, text: "Liked Songs", path: "/liked-songs" },
  ];

  const premiumItem = [
    { icon: <Icon.Trending className="w-5 h-5" />, text: "Premium Plans", path: "/premium" },
  ];

  return (
    <aside className={`fixed top-0 left-0 z-50 h-screen transition-all duration-300 ease-in-out ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} sm:translate-x-0 w-48 xs:w-56 sm:w-64 lg:w-72 bg-black/95 backdrop-blur-lg border-r border-gray-800 shadow-xl`}>
      <div className="flex flex-col h-full">
        <div className="p-2 xs:p-3 sm:p-4 border-b border-gray-800">
          <h1 className="text-base xs:text-lg sm:text-xl font-bold text-white flex items-center gap-2 xs:gap-3">
            {/* <Icon.Music className="w-4 h-4 xs:w-5 xs:h-5 sm:w-6 sm:h-6 text-green-500 flex-shrink-0" /> */}
            <img className="w-6 h-6 xs:w-8 xs:h-8 sm:w-10 sm:h-10 rounded-lg object-cover flex-shrink-0" src={logo} alt="Sama Logo" />
            <span className="text-green-400 font-semibold truncate">Sama</span>
          </h1>
        </div>
        <nav className="flex-1 p-2 xs:p-3 sm:p-4 space-y-1">
          {menuItems.map((item, i) => (
            <button
              key={i}
              onClick={() => {
                navigate(item.path);
                if (window.innerWidth < 640) {
                  setSidebarOpen(false);
                }
              }}
              className={`flex items-center gap-2 xs:gap-3 w-full p-2 xs:p-3 sm:p-3 rounded-lg transition-all duration-200 touch-manipulation min-h-[44px] xs:min-h-[48px] ${
                currentPath === item.path
                  ? 'bg-green-600 text-white shadow-lg'
                  : 'text-gray-300 hover:bg-gray-800 active:bg-gray-700'
              }`}
            >
              <div className="flex-shrink-0">
                {item.icon}
              </div>
              <span className="truncate text-sm sm:text-base">{item.text}</span>
            </button>
          ))}

          <div className="pt-4 xs:pt-6 sm:pt-8 space-y-1">
            {playlistItems.map((item, i) => (
              <button
                key={i}
                onClick={() => {
                  navigate(item.path);
                  if (window.innerWidth < 640) {
                    setSidebarOpen(false);
                  }
                }}
                className={`flex items-center gap-2 xs:gap-3 w-full p-2 xs:p-3 sm:p-3 rounded-lg transition-all duration-200 touch-manipulation min-h-[44px] xs:min-h-[48px] ${
                  currentPath === item.path
                    ? 'bg-green-600 text-white shadow-lg'
                    : 'text-gray-300 hover:bg-gray-800 active:bg-gray-700'
                }`}
              >
                <div className="flex-shrink-0">
                  {item.icon}
                </div>
                <span className="truncate text-xs xs:text-sm sm:text-base">{item.text}</span>
              </button>
            ))}

            <div className="pt-2 xs:pt-3 sm:pt-4 border-t border-gray-800">
              {premiumItem.map((item, i) => (
                <button
                  key={i}
                  onClick={() => {
                    navigate(item.path);
                    if (window.innerWidth < 640) {
                      setSidebarOpen(false);
                    }
                  }}
                  className={`flex items-center gap-2 xs:gap-3 w-full p-2 xs:p-3 sm:p-3 rounded-lg transition-all duration-200 touch-manipulation min-h-[44px] xs:min-h-[48px] ${
                    currentPath === item.path
                      ? 'bg-gradient-to-r from-green-600 to-green-500 text-white shadow-lg'
                      : 'text-gray-300 hover:bg-gray-800 active:bg-gray-700'
                  }`}
                >
                  <div className="flex-shrink-0">
                    {item.icon}
                  </div>
                  <span className="truncate font-semibold text-sm sm:text-base">{item.text}</span>
                </button>
              ))}
            </div>
          </div>
        </nav>
      </div>
    </aside>
  );
};

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();

  const userEmail = localStorage.getItem('userEmail');

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('userEmail');
    navigate('/login');
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-b from-gray-900 via-black to-gray-900 text-gray-100 flex flex-col mobile-tap-highlight">
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} currentPath={currentPath} />

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-30 sm:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <main className={`transition-all duration-300 flex-1 ml-0 xs:ml-56 sm:ml-64 lg:ml-72`}>
        {/* Header - Hidden on Search, Create Playlist, Liked Songs, Premium pages, and Music Player Demo */}
        {currentPath !== '/search' && currentPath !== '/create-playlist' && currentPath !== '/liked-songs' && currentPath !== '/premium' && currentPath !== '/music-player-demo' && (
          <header className="sticky top-0 z-40 backdrop-blur-lg bg-gray-900/90 border-b border-gray-800">
          <div className="px-2 xs:px-3 sm:px-6 lg:px-8 py-2 xs:py-3 sm:py-4 flex items-center justify-between">
            <div className="flex items-center gap-1 xs:gap-2 sm:gap-4 min-w-0 flex-1">
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="sm:hidden p-1.5 xs:p-2 sm:p-3 rounded-lg bg-gray-800/50 hover:bg-gray-700/50 active:bg-gray-600/50 transition-all duration-200 touch-manipulation min-w-[40px] xs:min-w-[44px] sm:min-w-[48px] min-h-[40px] xs:min-h-[44px] sm:min-h-[48px] flex items-center justify-center"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
              <h1 className="text-sm xs:text-base sm:text-lg lg:text-xl font-semibold text-white truncate">
                {currentPath === '/' && 'Home'}
                {currentPath === '/search' && 'Search Music'}
                {currentPath === '/artists' && 'Artists & Singers'}
                {currentPath === '/library' && 'Your Library'}
                {currentPath === '/favourite' && 'Favourites'}
                {currentPath === '/chat' && 'Chat'}
                {currentPath === '/settings' && 'Settings'}
                {currentPath === '/premium' && 'Premium Plans'}
                {currentPath === '/create-playlist' && 'Create Playlist'}
                {currentPath === '/liked-songs' && 'Liked Songs'}
                {currentPath === '/privacy-policy' && 'Privacy Policy'}
                {currentPath === '/terms-conditions' && 'Terms & Conditions'}
                {currentPath === '/cancellation-refunds' && 'Cancellation & Refunds'}
                {currentPath === '/shipping' && 'Shipping'}
                {currentPath === '/contact' && 'Contact'}
                {currentPath === '/music-player-demo' && 'Music Player Demo'}
              </h1>
            </div>

            {/* User info and logout */}
            <div className="flex items-center gap-1 xs:gap-2 sm:gap-4 flex-shrink-0">
              <div className="hidden md:flex items-center gap-2 bg-gray-800/50 px-3 py-1.5 rounded-full border border-gray-700">
                <img className='h-6 w-6 rounded-full object-cover' src={logo} alt="User avatar"/>
                <span className="text-xs text-gray-300 truncate max-w-[100px]">
                  {userEmail}
                </span>
              </div>
              <button 
                onClick={handleLogout}
                className="p-2 xs:p-2.5 sm:p-3 rounded-full bg-red-500/80 hover:bg-red-500 active:bg-red-600 text-white transition-all duration-200 touch-manipulation flex items-center justify-center shadow-lg hover:shadow-red-500/30 transform hover:scale-105"
              >
                <Icon.Logout className="w-4 h-4 xs:w-5 xs:w-5" />
              </button>
            </div>
          </div>
        </header>
        )}

        {/* Page Content */}
        <div className="p-2 xs:p-3 sm:p-4 md:p-6 lg:p-8 min-h-screen pb-20 sm:pb-24">
          {children}
          {/* Ad Banner */}
        
        </div>
      </main>

      {/* Footer - Hidden on Create Playlist, Liked Songs, Premium Plans, Search pages, and Music Player Demo */}
      {currentPath !== '/create-playlist' && currentPath !== '/liked-songs' && currentPath !== '/premium' && currentPath !== '/search' && currentPath !== '/music-player-demo' && (
        <Footer />
      )}

      {/* Music Player - Always visible when a song is playing */}
      <MusicPlayer />
    </div>
  );
};

export { Icon };
export default Layout;